import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { UserOutlined } from '@ant-design/icons'
import { Menu, Dropdown, Avatar, Switch } from 'antd'
import styles from './style.module.scss'

const mapStateToProps = ({ user, settings }) => ({ user, settings })

const ProfileMenu = ({ dispatch, user, settings }) => {
  const [count, setCount] = useState(7)
  const menuColor = settings?.menuColor

  const logout = e => {
    e.preventDefault()
    dispatch({
      type: 'user/LOGOUT',
    })
  }

  const addCount = () => {
    setCount(count + 1)
  }

  const menu = (
    <Menu selectable={false}>
      <Menu.Item disabled style={{ cursor: 'default', padding: '12px 20px' }}>
        <div className="d-flex flex-column">
          <span className="font-size-12 text-muted" style={{ textTransform: 'uppercase', letterSpacing: '1px' }}>
            Account
          </span>
          <strong className="text-white font-size-14 mt-1">{user?.name || 'Tom Jones'}</strong>
          <span className="text-muted font-size-12">{user?.email || 'demo@sellpixels.com'}</span>
        </div>
      </Menu.Item>
      {user?.role === 'admin' && (
        <>
          <Menu.Divider />
          <Menu.Item disabled style={{ cursor: 'default', padding: '8px 20px' }}>
            <div className="d-flex align-items-center justify-content-between" style={{ gap: '15px' }}>
              <span className="font-size-13">Dark Sidebar</span>
              <Switch
                checkedChildren="On"
                unCheckedChildren="Off"
                checked={menuColor === 'dark'}
                onChange={checked => {
                  dispatch({
                    type: 'settings/CHANGE_SETTING',
                    payload: {
                      setting: 'menuColor',
                      value: checked ? 'dark' : 'white',
                    },
                  })
                }}
              />
            </div>
          </Menu.Item>
        </>
      )}
      <Menu.Divider />
      <Menu.Item>
        <a href="#" onClick={logout}>
          <i className="fe fe-log-out mr-2" />
          <FormattedMessage id="topBar.profileMenu.logout" />
        </a>
      </Menu.Item>
    </Menu>
  )
  return (
    <Dropdown overlay={menu} trigger={['click']} onVisibleChange={addCount}>
      <div className={styles.dropdown}>
        {/* <Badge count={count}> */}
        <Avatar className={styles.avatar} shape="circle" size="sm" icon={<UserOutlined />} />
        {/* </Badge> */}
      </div>
    </Dropdown>
  )
}

export default connect(mapStateToProps)(ProfileMenu)
